(function () {
  if (!document.querySelector(".section-l4-page-base")) {
    return;
  }

  var AUTO_MS = 5000;
  var USER_PAUSE_MS = 10000;
  var STAGGER_STEP_MS = 450;
  var staggerSeq = 0;

  function L4AutoAdvanceController(options) {
    options = options || {};
    var getCount = options.getCount || function () {
      return 0;
    };
    var onAdvance = options.onAdvance || function () {};
    var root = options.root || null;
    var staggerIndex = options.staggerIndex;
    if (staggerIndex == null) {
      staggerIndex = staggerSeq++;
    }

    var timer = null;
    var delayMs = AUTO_MS;
    var destroyed = false;
    var visible = true;
    var io = null;

    function clearTimer() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function schedule() {
      clearTimer();
      if (destroyed || !visible || getCount() <= 1) {
        return;
      }
      timer = setTimeout(function () {
        if (destroyed) {
          return;
        }
        onAdvance();
        delayMs = AUTO_MS;
        schedule();
      }, delayMs);
    }

    function bumpUser() {
      if (destroyed) {
        return;
      }
      delayMs = USER_PAUSE_MS;
      schedule();
    }

    if (root && typeof IntersectionObserver !== "undefined") {
      io = new IntersectionObserver(
        function (entries) {
          visible = Boolean(entries[0] && entries[0].isIntersecting);
          if (visible) {
            schedule();
          } else {
            clearTimer();
          }
        },
        { threshold: 0.2 }
      );
      io.observe(root);
    }

    setTimeout(function () {
      if (!destroyed) {
        schedule();
      }
    }, staggerIndex * STAGGER_STEP_MS);

    return {
      bumpUser: bumpUser,
      pause: clearTimer,
      resume: schedule,
      destroy: function () {
        destroyed = true;
        clearTimer();
        if (io) {
          io.disconnect();
        }
      }
    };
  }

  window.L4AutoAdvance = {
    AUTO_MS: AUTO_MS,
    USER_PAUSE_MS: USER_PAUSE_MS,
    create: function (options) {
      return new L4AutoAdvanceController(options);
    }
  };
})();
